var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user-guide" },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("layout.guideLayout.title"))),
      ]),
      _c("div", { staticClass: "sub-title" }, [
        _vm._v(_vm._s(_vm.$t("layout.guideLayout.step1"))),
      ]),
      _c("p", [_vm._v(_vm._s(_vm.$t("layout.guideLayout.p1")))]),
      _c("p", [_vm._v(_vm._s(_vm.$t("layout.guideLayout.p2")))]),
      _c("div", { staticClass: "platform-list" }, [
        _c(
          "div",
          {
            staticClass: "platform-item",
            on: {
              click: function ($event) {
                return _vm.handleBindStore("amazon")
              },
            },
          },
          [
            _c("div", { staticClass: "box" }, [
              _c("span", { staticClass: "name" }, [_vm._v("Amazon")]),
              _c("span", { staticClass: "badge" }, [
                _vm._v(_vm._s(_vm.$t("layout.guideLayout.amazon.title"))),
              ]),
            ]),
            _c("div", [
              _vm._v(_vm._s(_vm.$t("layout.guideLayout.amazon.click"))),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "platform-item",
            on: {
              click: function ($event) {
                return _vm.handleBindStore("shopify")
              },
            },
          },
          [
            _vm._m(0),
            _c("div", [
              _vm._v(_vm._s(_vm.$t("layout.guideLayout.shopify.click"))),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "platform-item",
            on: {
              click: function ($event) {
                return _vm.handleBindStore("semitemu")
              },
            },
          },
          [
            _vm._m(1),
            _c("div", [
              _vm._v(_vm._s(_vm.$t("layout.guideLayout.temu.click"))),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "platform-item",
            on: {
              click: function ($event) {
                return _vm.handleBindStore("tiktok")
              },
            },
          },
          [
            _vm._m(2),
            _c("div", [
              _vm._v(_vm._s(_vm.$t("layout.guideLayout.tiktok.click"))),
            ]),
          ]
        ),
        _c("div", { staticClass: "platform-item platform-item-more" }, [
          _c("div", { staticClass: "box" }, [
            _c("span", { staticClass: "tips" }, [
              _vm._v(_vm._s(_vm.$t("layout.guideLayout.morePlatform"))),
            ]),
          ]),
        ]),
      ]),
      _c("p", { staticClass: "bottom-tips" }, [
        _vm._v(" " + _vm._s(_vm.$t("layout.guideLayout.p3")) + " "),
        _c(
          "a",
          {
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toDemo.apply(null, arguments)
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("layout.guideLayout.p4")))]
        ),
        _vm._v(" " + _vm._s(_vm.$t("layout.guideLayout.p5")) + " "),
      ]),
      _c("p", [_vm._v(_vm._s(_vm.$t("layout.guideLayout.p2")))]),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("layout.guideLayout.店铺授权"),
            bodyStyle: {
              padding: "0 10px 0 30px",
              backgroundColor: "white",
              height: _vm.modalHeight,
            },
            width: 730,
            footer: null,
            maskClosable: false,
            "destroy-on-close": "",
          },
          model: {
            value: _vm.open,
            callback: function ($$v) {
              _vm.open = $$v
            },
            expression: "open",
          },
        },
        [
          _c("iframe", {
            ref: "StoreAuthRef",
            staticStyle: {
              width: "100%",
              height: "100%",
              "border-radius": "0px",
              overflow: "hidden",
              border: "unset",
            },
            attrs: { src: _vm.iframeSrc },
          }),
        ]
      ),
      _c("ModalSuccess", { ref: "ModalSuccessRef" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box" }, [
      _c("span", { staticClass: "name" }, [
        _c("img", {
          staticStyle: { "margin-bottom": "-3px" },
          attrs: {
            width: "46",
            height: "46",
            src: require("@/assets/platform/shopify.png"),
          },
        }),
        _vm._v(" Shopify "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box" }, [
      _c("span", { staticClass: "name" }, [
        _c("img", {
          staticStyle: {
            "margin-right": "5px",
            "margin-bottom": "4px",
            "border-radius": "10px",
          },
          attrs: {
            width: "36",
            height: "36",
            src: require("@/assets/platform/semitemu.png"),
          },
        }),
        _vm._v(" TEMU半托管 "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box" }, [
      _c("span", { staticClass: "name" }, [
        _c("img", {
          staticStyle: { "margin-right": "5px", "margin-bottom": "3px" },
          attrs: {
            width: "36",
            height: "36",
            src: require("@/assets/platform/tiktok.png"),
          },
        }),
        _vm._v(" Tiktok "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }